<template>
  <div class="share-container">
    <div v-if="loadingType">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div class="operation-box">
      <div class="common-button-box">
        <el-button
          class="normal-btn"
          v-if="isChecked('Project.Single.Share.Cancel')"
          size="small"
          @click="batchCancelShare"
          >批量取消分享</el-button
        >
      </div>
      <div class="filter-box">
        <div class="cascader-box">
          <span class="label-box searchLabel gr16">资源类型</span>
          <div class="common-select-box">
            <el-cascader
              v-if="showCascader"
              :append-to-body="false"
              class="primary-select"
              size="small"
              popper-class="common-cascader-box"
              v-model="resourceType"
              :options="resourceOptions"
              @change="handleCascaderChange"
              @visible-change="visibleChange"></el-cascader>
          </div>
        </div>
        <div class="gl16">
          <el-input
            class="search-input input-primary"
            size="small"
            v-model="keywords"
            placeholder="请输入资源名称"
            clearable
            @clear="search"
            @keyup.enter.native="search">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="search" />
          </el-input>
        </div>
      </div>
    </div>
    <div class="common-tabs-box">
      <el-tabs
        class="tab-page-primary"
        v-model="activeTab"
        @tab-click="onTabClick">
        <el-tab-pane
          label="链接分享"
          name="linkShare">
          <div
            class="common-table-box"
            v-if="activeTab === 'linkShare'">
            <el-table
              ref="modelTable"
              highlight-selection-row
              :header-row-class-name="customHeader"
              class="publish-table"
              :data="shareList"
              height="100%"
              @select="selectChange"
              @select-all="selectChange">
              <el-table-column
                type="selection"
                width="60">
              </el-table-column>
              <el-table-column
                label="序号"
                type="index"
                width="55"></el-table-column>
              <el-table-column
                label="资源名称"
                width="360">
                <template v-slot="{ row }">
                  <span
                    :class="`text-overflow ${
                      row.isValidShare ? 'link-style' : 'disabled-style'
                    }`"
                    :title="row.resourceName"
                    @click="modelView(row)"
                    >{{ row.resourceName }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="分享时间"
                width="240">
                <template v-slot="{ row }">
                  <span>{{ formatTime(row.limitedTimeBegin) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="到期时间"
                width="240">
                <template v-slot="{ row }">
                  <div class="limited-timeend-box">
                    <div :class="`circle ${row.limitedTimeEndClass}-bg`"></div>
                    <span :class="`${row.limitedTimeEndClass}`">
                      {{ row.limitedTimeEnd }}</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="浏览次数">
                <template v-slot="{ row }">
                  <span>{{ row.count }}</span>
                </template>
              </el-table-column>
              <el-table-column label="资源类型">
                <template v-slot="{ row }">
                  <span>{{ formatResourceType(row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="所属项目">
                <template v-slot="{ row }">
                  <span>{{ row.projName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="150">
                <template v-slot="{ row }">
                  <div class="common-button-box operation-cell">
                    <el-button
                      :class="
                        row.isValidShare ? 'copy' : 'disabled-style disabled'
                      "
                      type="text"
                      size="small"
                      data-clipboard-action="copy"
                      :data-clipboard-text="getCopyText(row)"
                      @click="copyShareLink"
                      >复制链接</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      v-if="isChecked('Project.Single.Share.Cancel')"
                      @click="cancelShareById(row)"
                      >取消分享</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="common-empty-box">
                  <bj-empty
                    :image="require('@/assets/img/no-data.png')"
                    class="empty-page">
                    <template slot="description">
                      <div class="empty-text">抱歉，没有找到相关内容</div>
                    </template>
                  </bj-empty>
                </div>
              </template>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="用户分享"
          name="userShare">
          <div
            class="common-table-box"
            v-if="activeTab === 'userShare'">
            <el-table
              highlight-selection-row
              :header-row-class-name="customHeaderUser"
              ref="modelTableUser"
              class="publish-table"
              :data="shareList"
              height="100%"
              @select="selectChange"
              @select-all="selectChange">
              <el-table-column
                type="selection"
                width="60">
              </el-table-column>
              <el-table-column
                label="序号"
                type="index"
                width="55"></el-table-column>
              <el-table-column
                label="资源名称"
                width="360">
                <template v-slot="{ row }">
                  <span
                    :class="`text-overflow ${
                      row.isValidShare ? 'link-style' : 'disabled-style'
                    }`"
                    :title="row.resourceName"
                    @click="modelView(row)"
                    >{{ row.resourceName }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="用户">
                <template v-slot="{ row }">
                  <span>{{ row.shareToUserName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="分享时间"
                width="240">
                <template v-slot="{ row }">
                  <span>{{ formatTime(row.limitedTimeBegin) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="到期时间"
                width="240">
                <template v-slot="{ row }">
                  <div class="limited-timeend-box">
                    <div :class="`circle ${row.limitedTimeEndClass}-bg`"></div>
                    <span :class="`${row.limitedTimeEndClass}`">
                      {{ row.limitedTimeEnd }}</span
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="浏览次数">
                <template v-slot="{ row }">
                  <span>{{ row.count }}</span>
                </template>
              </el-table-column>
              <el-table-column label="资源类型">
                <template v-slot="{ row }">
                  <span>{{ formatResourceType(row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="所属项目">
                <template v-slot="{ row }">
                  <span>{{ row.projName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100">
                <template v-slot="{ row }">
                  <div class="common-button-box operation-cell">
                    <el-button
                      type="text"
                      size="small"
                      v-if="isChecked('Project.Single.Share.Cancel')"
                      @click="cancelShareById(row)"
                      >取消分享</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="common-empty-box">
                  <bj-empty
                    :image="require('@/assets/img/no-data.png')"
                    class="empty-page">
                    <template slot="description">
                      <div class="empty-text">抱歉，没有找到相关内容</div>
                    </template>
                  </bj-empty>
                </div>
              </template>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="common-pagination-box pagination-primary">
      <el-pagination
        popper-class="common-pagination-popper-box"
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 150, 200]"
        :page-size="pageSize"
        :current-page="currentPage"
        :total="total"
        @size-change="sizeChange"
        @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { Store } from '@/utils/store'
import { formatTime } from '@/utils/generalMethods'
import Spin from '@/components/Spin.vue'

import {
  qureyShareListService,
  cancelShareService,
  generateUser
} from '@/service/interface'

export default {
  data() {
    return {
      activeTab: 'linkShare',
      keywords: '',
      resourceType: ['all'],
      resourceOptions: [
        { value: 'all', label: '所有' },
        {
          value: 'dataSet',
          label: '数据集',
          children: [
            { value: 'all', label: '全部' },
            { value: 1, label: '模型' },
            { value: 2, label: '模型组' },
            { value: 3, label: '遥感影像' },
            { value: 4, label: 'Wmts' },
            { value: 5, label: '倾斜摄影' },
            { value: 6, label: '360全景图' },
            { value: 7, label: '点云' },
            { value: 8, label: '二维图纸' },
            { value: 9, label: '矢量' }
          ]
        },
        { value: 0, label: '场景' }
      ],

      shareList: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      selectShares: [],
      timer: null,
      customHeader: '',
      customHeaderUser: '',
      loadingType: true,
      showCascader: true
    }
  },
  components: { Spin },
  mounted() {
    this.$nextTick(() => {
      const currentBody = this.$refs.modelTable?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    })

    this.qureyShareList()
    this.timer = setInterval(this.qureyShareList, 1 * 60 * 1000)

    let copybtn = document.getElementsByClassName('copy')
    this.clipboard = new Clipboard(copybtn)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    qureyShareList() {
      let filter = this.getResourceTypeFilter()
      this.loadingType = true
      let shareType = this.activeTab === 'userShare' ? 1 : 2
      let params = {
        shareType,
        resourceName: this.keywords,
        resourceSubType: filter.resourceSubType,
        resourceType: filter.resourceType,
        skipCount: (this.currentPage - 1) * this.pageSize,
        resultCount: this.pageSize,
        showReadCount: true,
        showProjectName: true
      }
      qureyShareListService(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          this.shareList = this.formatShareList(data.items)
          this.total = data.totalCount
          this.loadingType = false
          if (this.activeTab === 'linkShare') {
            this.$nextTick(() => {
              this.initClipboard()
            })
          }
        }
      })
    },
    handleCascaderChange() {
      this.keywords = ''
      this.currentPage = 1
      this.pageSize = 10
      this.qureyShareList()
    },
    visibleChange(flag) {
      if (flag) return
      this.showCascader = false
      this.$nextTick(() => {
        this.showCascader = true
      })
    },
    search() {
      this.currentPage = 1
      this.qureyShareList()
    },
    onTabClick() {
      this.resourceType = ['all']
      this.keywords = ''
      this.currentPage = 1
      this.pageSize = 10
      this.qureyShareList()
      this.$nextTick(() => {
        const currentBody = this.$refs.modelTable?.bodyWrapper
        currentBody &&
          currentBody.addEventListener('scroll', ev => {
            const scrollTop = ev.target.scrollTop
            this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
          })

        const modelTableUser = this.$refs.modelTableUser?.bodyWrapper
        modelTableUser &&
          modelTableUser.addEventListener('scroll', ev => {
            const scrollTop = ev.target.scrollTop
            this.customHeaderUser = scrollTop > 10 ? 'darkHeader' : ''
          })
      })
    },
    pageChange(currentPage) {
      this.currentPage = currentPage
      this.qureyShareList()
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currentPage = 1
      this.qureyShareList()
    },
    selectChange(selection) {
      this.selectShares = selection
    },
    batchCancelShare() {
      if (!this.selectShares.length) {
        this.$message.warning('请先选择需要取消分享的资源！')
        return
      }
      let shareIds = this.selectShares.map(el => el.shareId)
      let params = { shareIds }
      cancelShareService(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('取消分享成功！！！')
          this.selectShares = []
          this.qureyShareList()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    initClipboard() {
      let copybtn = document.getElementsByClassName('copy')
      this.clipboard = new Clipboard(copybtn)
    },
    getCopyText(shareInfo) {
      if (!shareInfo.isValidShare) return

      let pageUrl = ''
      let resourceType = shareInfo.resourceType
      if (resourceType === 0) {
        pageUrl = 'sceneShare/view'
      } else {
        pageUrl = 'dataSetShare/view'
      }

      let copyText = ''
      if (resourceType === 0) {
        copyText = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${shareInfo.shareId}/${shareInfo.resourceId}?viewMode=${shareInfo.displayMode}&token=${shareInfo.shareToToken}`
      } else {
        let dataType = this.getDataType(shareInfo.resourceSubType)
        copyText = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${shareInfo.shareId}/${shareInfo.resourceId}?dataType=${dataType}&token=${shareInfo.shareToToken}`
      }

      return copyText
    },
    modelView(resourceInfo) {
      if (!resourceInfo.isValidShare) return

      let pageUrl = ''
      let resourceType = resourceInfo.resourceType
      if (resourceType === 0) {
        pageUrl = 'sceneShare/view'
      } else {
        pageUrl = 'dataSetShare/view'
      }
      let shareType = resourceInfo.shareType
      if (shareType === 2) {
        let url = ''
        if (resourceType === 0) {
          url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?viewMode=${resourceInfo.displayMode}&token=${resourceInfo.shareToToken}`
        } else {
          let dataType = this.getDataType(resourceInfo.resourceSubType)
          url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?dataType=${dataType}&token=${resourceInfo.shareToToken}`
        }

        window.open(url, '_blank')
      } else {
        let params = {
          userId: resourceInfo.shareToUserId,
          sceneId: resourceInfo.resourceId
        }
        generateUser(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data) {
              let url = ''
              if (resourceType === 0) {
                url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?viewMode=${resourceInfo.displayMode}&token=${resourceInfo.shareToToken}`
              } else {
                let dataType = this.getDataType(resourceInfo.resourceSubType)
                url = `${window.location.origin}${window.location.pathname}#/${pageUrl}/${resourceInfo.shareId}/${resourceInfo.resourceId}?dataType=${dataType}&token=${resourceInfo.shareToToken}`
              }

              window.open(url, '_blank')
            }
          }
        })
      }
    },
    copyShareLink() {
      this.clipboard.on('success', () => {
        this.$message.success('复制成功！')
      })

      this.clipboard.on('error', () => {
        this.$message.error('复制失败，请手动复制！')
      })
    },
    cancelShareById(shareInfo) {
      let params = {
        shareIds: [shareInfo.shareId]
      }
      cancelShareService(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('取消分享成功！！！')
          this.selectShares = []
          this.qureyShareList()
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    formatShareList(shareList) {
      shareList = shareList.map(item => {
        let obj = {
          shareType: item.shareType,
          shareId: item.shareId,
          resourceId: item.resourceId,
          resourceName: item.resourceName,
          shareToUserName: item.shareToUserName,
          isValidShare: this.isValidShare(item),
          limitedTimeBegin: item.limitedTimeBegin,
          limitedTimeEnd: this.getLimitedTimeEnd(item),
          limitedTimeEndClass: this.getLimitedTimeEndClass(item),
          resourceType: item.resourceType,
          resourceSubType: item.resourceSubType,
          displayMode: item.displayMode,
          projName: item.projName,
          count: item.accessCount,
          shareToToken: item.shareToToken,
          shareToUserId: item.shareToUserId
        }
        return obj
      })
      return shareList
    },
    getResourceTypeFilter() {
      let resourceType = undefined
      let resourceSubType = undefined
      if (this.resourceType.length === 1) {
        if (this.resourceType[0] === 0) {
          resourceType = 0
        }
      }
      if (this.resourceType.length === 2) {
        let subType = this.resourceType[1]
        if (subType === 'all') {
          resourceType = 2
        } else {
          resourceType = 2
          resourceSubType = subType
        }
      }
      return { resourceType, resourceSubType }
    },
    getLimitedTimeEnd(item) {
      let limitedTime = item.limitedTime

      let currentTime = new Date().getTime()
      let endTime = new Date(Date.parse(item.limitedTimeEnd)).getTime()

      if (limitedTime === 4) {
        return '永久有效'
      }

      if (currentTime - endTime > 0) {
        return '已过期'
      }

      return this.formatTime(item.limitedTimeEnd)
    },
    getLimitedTimeEndClass(item) {
      let limitedTime = item.limitedTime

      let currentTime = new Date().getTime()
      let endTime = new Date(Date.parse(item.limitedTimeEnd)).getTime()

      if (limitedTime === 4) {
        return 'forever'
      }

      if (currentTime - endTime > 0) {
        return 'overtime'
      }

      return 'normal'
    },
    /**
     * 分享是否过期
     */
    isValidShare(share) {
      let limitedTime = share.limitedTime

      let currentTime = new Date().getTime()
      let endTime = new Date(Date.parse(share.limitedTimeEnd)).getTime()

      if (limitedTime === 4) {
        return true
      }

      if (currentTime - endTime > 0) {
        return false
      }

      return true
    },
    getDataType(resourceSubType) {
      let dataTypeArray = [
        { value: 1, label: 'Bim' },
        { value: 2, label: 'Bim' },
        { value: 3, label: 'Rs' },
        { value: 4, label: 'Wmts' },
        { value: 5, label: 'Osgb' },
        { value: 6, label: 'Panorama' },
        { value: 7, label: 'PointCloud' },
        { value: 8, label: 'Cad' },
        { value: 9, label: 'Vector' }
      ]
      let find = dataTypeArray.find(el => el.value === resourceSubType)
      return find?.label ?? ''
    },
    formatResourceType(shareInfo) {
      const dataTypeMap = [
        '场景',
        '模型',
        '模型组',
        '遥感影像',
        'WMTS地图服务',
        '倾斜摄影',
        '360全景图',
        '点云',
        '二维图纸',
        '矢量'
      ]

      let { resourceType, resourceSubType } = shareInfo
      if (resourceType === 0) {
        return dataTypeMap[0]
      } else {
        return dataTypeMap[resourceSubType]
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/publishSearch.less');
@import url('@/assets/css/pageStyle.less');
.share-container {
  position: relative;
  padding: 16px;
  padding-top: 4px;
  height: 100%;
  width: 100%;
  margin-left: 0 !important;
  background: var(--page-bgColor);
  box-shadow: var(--page-shadow-bgColor);
  .operation-box {
    position: absolute;
    width: calc(100% - 32px);
    top: 65px;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    // padding: 0px 20px;

    .common-button-box {
      margin: auto 0px;
      // .el-button--default {
      //   height: unset;
      // }
    }

    .filter-box {
      display: flex;
      .cascader-box {
        display: flex;
        .label-box {
          line-height: 32px;
        }
      }

      // .common-input-box {
      //   margin-left: 10px;
      // }
    }
  }

  .common-table-box {
    height: calc(100% - 52px);
    margin-top: 65px;

    .publish-table {
      :deep(.el-table__body-wrapper) {
        .el-table__row {
          // background-color: var(--aside-bg-color);
        }
      }
    }

    .link-style {
      cursor: pointer;
      &:hover {
        color: var(--base-primary-bgColor);
        text-decoration: underline;
      }
    }

    .disabled-style {
      cursor: not-allowed;
      color: var(--disabled-text-color);
    }

    .common-button-box {
      display: flex;
    }

    .limited-timeend-box {
      display: flex;
      .circle {
        width: 5px;
        height: 5px;
        margin: auto 10px auto 0px;
        border-radius: 50%;
      }

      .normal {
        color: var(--runing-status-color);
      }

      .normal-bg {
        background-color: var(--runing-status-color);
      }

      .overtime {
        color: var(--error-status-color);
      }

      .overtime-bg {
        background-color: var(--error-status-color);
      }

      .forever {
        color: var(--success-status-color);
      }

      .forever-bg {
        background-color: var(--success-status-color);
      }
    }
  }

  .common-pagination-box {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-right: 20px;
  }

  .common-tabs-box {
    height: 100%;
    :deep(.el-tabs) {
      height: 100%;
      .el-tabs__header {
        padding: 0;
      }

      .el-tabs__content {
        height: calc(100% - 32px);

        .el-tab-pane {
          height: calc(100% - 55px);
        }
      }
    }

    .tab-primary {
      height: 100%;
    }
  }
}
</style>
